function Flags(this: TODOAny) {
  // perf: explicit hidden class, do not call reset
  this.break = false
  this.skip = false
  this.remove = false
  this.replace = null
}

Flags.prototype = {
  reset() {
    this.break = false
    this.skip = false
    this.remove = false
    this.replace = null
  },
}

export default function FlagsFactory() {
    // this is legacy code. we don't want to rewrite it to a class right now.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new (Flags as any)();
}
